import isTranslationKey from "./isTranslationKey";

const resolveNotificationText = (
  text: string | undefined,
  translations: Partial<Record<string, string>> | undefined,
): string => {
  if (!text) {
    return "";
  }
  if (!isTranslationKey(text)) {
    return text;
  }
  const translation = translations?.[text.trim()];
  if (!translation) {
    return text;
  }
  return translation;
};

export default resolveNotificationText;
